<template>
  <div class="customize-page">
    <!-- 固定顶部区域 -->
    <div class="fixed-top">
      <!-- 顶部标题栏 -->
      <div class="header">
        <div class="back-btn" @click="goBack">
          <svg viewBox="0 0 24 24" class="back-icon">
            <path d="M15 18 L9 12 L15 6" fill="none" stroke="#323233" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="title">服务</div>
        <div class="done-btn" @click="goBack">
          <svg viewBox="0 0 24 24" class="check-icon"><path d="M4 12 L10 18 L20 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          <span>完成</span>
        </div>
      </div>

      <!-- 搜索栏 -->
      <div class="search-wrap">
        <div class="search-input">
          <svg viewBox="0 0 24 24" class="search-icon">
            <circle cx="11" cy="11" r="7" fill="none" stroke="#999" stroke-width="2"/>
            <path d="M16 16 L21 21" stroke="#999" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <span class="placeholder">请输入关键字搜索</span>
        </div>
      </div>

      <!-- 我的应用 -->
      <div class="my-apps-section">
        <div class="section-label">我的应用</div>
        <div class="my-apps-grid" v-if="myApps.length > 0">
          <div class="my-app-item" v-for="(app, idx) in myApps" :key="idx">
            <div class="remove-btn" @click="removeApp(app)">
              <svg viewBox="0 0 24 24" class="remove-icon">
                <circle cx="12" cy="12" r="10" fill="#999"/>
                <line x1="8" y1="12" x2="16" y2="12" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </div>
            <img :src="app.icon || defaultIcon" class="app-icon" :alt="app.title" />
            <span class="app-name">{{ app.title }}</span>
          </div>
        </div>
        <div class="empty-tip" v-else>暂无应用，点击下方添加</div>
      </div>

      <!-- 分类标签 -->
      <div class="tabs">
        <div
          v-for="(tab, i) in tabs"
          :key="tab"
          :class="['tab', { active: activeTab === i }]"
          @click="scrollToGroup(i)"
        >{{ tab }}</div>
      </div>
    </div>

    <!-- 服务列表 -->
    <div class="service-list" :style="{ paddingTop: listTopPadding }">
      <div v-for="(group, idx) in serviceGroups" :key="group.name" class="service-group" :ref="'group-' + idx">
        <div class="group-title">{{ group.name }}</div>
        <template v-for="item in group.items">
          <!-- 父项 -->
          <div
            :key="item.title"
            class="service-item"
          >
            <img :src="getIcon(item.icon)" class="item-icon" :alt="item.title" />
            <span class="item-title">{{ item.title }}</span>
            <div v-if="item.expand" class="item-expand" :class="{ expanded: expandedItems[item.title] }" @click.stop="toggleExpand(item)">
              <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="none" stroke="#c8c9cc" stroke-width="1.5"/><path d="M8 10 L12 14 L16 10" fill="none" stroke="#c8c9cc" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </div>
            <div v-else class="action-btn" @click.stop="toggleApp(item)">
              <svg v-if="isAdded(item)" viewBox="0 0 24 24" class="check-icon">
                <circle cx="12" cy="12" r="10" fill="none" stroke="#c8c9cc" stroke-width="2"/>
                <path d="M7 12 L11 16 L17 8" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg v-else viewBox="0 0 24 24" class="plus-icon">
                <circle cx="12" cy="12" r="10" fill="none" stroke="#07c160" stroke-width="2"/>
                <line x1="12" y1="8" x2="12" y2="16" stroke="#07c160" stroke-width="2" stroke-linecap="round"/>
                <line x1="8" y1="12" x2="16" y2="12" stroke="#07c160" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </div>
          </div>
          <!-- 子项 -->
          <template v-if="expandedItems[item.title] && item.children">
            <div
              v-for="child in item.children"
              :key="item.title + '-' + child.title"
              class="service-item child-item"
            >
              <span class="child-dot"></span>
              <span class="item-title">{{ child.title }}</span>
              <div class="action-btn" @click.stop="toggleApp(child, item)">
                <svg v-if="isAdded(child)" viewBox="0 0 24 24" class="check-icon">
                  <circle cx="12" cy="12" r="10" fill="none" stroke="#c8c9cc" stroke-width="2"/>
                  <path d="M7 12 L11 16 L17 8" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <svg v-else viewBox="0 0 24 24" class="plus-icon">
                  <circle cx="12" cy="12" r="10" fill="none" stroke="#07c160" stroke-width="2"/>
                  <line x1="12" y1="8" x2="12" y2="16" stroke="#07c160" stroke-width="2" stroke-linecap="round"/>
                  <line x1="8" y1="12" x2="16" y2="12" stroke="#07c160" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import serviceGroups from '@/data/services'
const iconContext = require.context('@/assets/icons', false, /\.png$/)
const icons = {}
iconContext.keys().forEach(key => {
  const name = key.replace(/^\.\//, '').replace(/\.png$/, '')
  icons[name] = iconContext(key)
})

export default {
  name: 'ServiceCustomize',
  data() {
    return {
      activeTab: 0,
      tabs: ['就业创业', '社会保险', '人才人事', '劳动关系', '社会保障卡'],
      serviceGroups,
      expandedItems: {},
      listTopPadding: '0px',
      myApps: [
      { title: '个人权益记录查询打印', icon: icons['svc-rights-print'], path: '/rights-record-print' }
    ]
    }
  },
  created() {
    // 从 localStorage 恢复我的应用
    const saved = localStorage.getItem('myApps')
    if (saved) {
      try {
        const parsed = JSON.parse(saved)
        if (Array.isArray(parsed)) {
          // 迁移：本地存的图标是旧构建 hash URL，重建后会 404，按标题刷新为当前资源
          const defaults = this.myApps
          parsed.forEach(a => {
            const def = defaults.find(d => d.title === a.title)
            if (def) {
              a.icon = def.icon
              a.path = def.path
            } else {
              // 定制列表内的服务项图标存的是图标名，需解析为当前资源
              const found = this.findServiceByTitle(a.title)
              if (found) a.icon = this.getIcon(found.icon)
            }
          })
          this.myApps = parsed
        }
      } catch (e) {
        this.myApps = []
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      const fixedTop = this.$el.querySelector('.fixed-top')
      if (fixedTop) {
        this.listTopPadding = fixedTop.offsetHeight + 'px'
      }
    })
  },
  methods: {
    getIcon(name) {
      return icons[name] || ''
    },
    // 按标题在全部分类（含子项）中查找服务定义，用于恢复本地数据时刷新图标
    findServiceByTitle(title) {
      for (const group of serviceGroups) {
        for (const item of group.items) {
          if (item.title === title) return item
          if (item.children) {
            const child = item.children.find(c => c.title === title)
            if (child) return child
          }
        }
      }
      return null
    },
    goBack() {
      // 保存我的应用到 localStorage
      localStorage.setItem('myApps', JSON.stringify(this.myApps))
      this.$router.push('/service')
    },
    toggleExpand(item) {
      this.$set(this.expandedItems, item.title, !this.expandedItems[item.title])
    },
    isAdded(item) {
      return this.myApps.some(app => app.title === item.title)
    },
    toggleApp(item, parent) {
      const index = this.myApps.findIndex(app => app.title === item.title)
      if (index >= 0) {
        this.myApps.splice(index, 1)
      } else {
        const icon = item.icon || (parent && parent.icon) || 'svc-default'
        this.myApps.push({
          title: item.title,
          icon: this.getIcon(icon),
          path: item.path || (parent && parent.path) || ''
        })
      }
    },
    removeApp(app) {
      const index = this.myApps.findIndex(a => a.title === app.title)
      if (index >= 0) {
        this.myApps.splice(index, 1)
      }
    },
    scrollToGroup(idx) {
      this.activeTab = idx
      const groupEl = this.$refs['group-' + idx] && this.$refs['group-' + idx][0]
      if (groupEl) {
        const container = groupEl.closest('.page-container') || document.documentElement
        const fixedTop = this.$el.querySelector('.fixed-top')
        const fixedHeight = fixedTop ? fixedTop.offsetHeight : 0
        const top = groupEl.getBoundingClientRect().top - container.getBoundingClientRect().top + container.scrollTop - fixedHeight
        container.scrollTo({ top, behavior: 'smooth' })
      }
    }
  }
}
</script>

<style scoped>
.customize-page {
  background: #f5f5f5;
  min-height: 100%;
}
.fixed-top {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: #fff;
}
.header {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(112 * var(--w));
  background: #fff;
  border-bottom: 1px solid #ebebeb;
}
.back-btn {
  position: absolute;
  left: calc(24 * var(--w));
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  cursor: pointer;
}
.back-icon {
  width: calc(44 * var(--w));
  height: calc(44 * var(--w));
}
.title {
  font-size: calc(52 * var(--w));
  font-weight: 500;
  color: #323233;
}
.done-btn {
  position: absolute;
  right: calc(32 * var(--w));
  top: 50%;
  transform: translateY(-50%);
  font-size: calc(36 * var(--w));
  color: #ff976a;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: calc(8 * var(--w));
}
.check-icon {
  width: calc(36 * var(--w));
  height: calc(36 * var(--w));
}
.search-wrap {
  background: #fff;
  padding: 0 calc(24 * var(--w)) calc(16 * var(--w));
}
.search-input {
  height: calc(72 * var(--w));
  background: #f2f2f2;
  border-radius: calc(36 * var(--w));
  display: flex;
  align-items: center;
  justify-content: center;
  gap: calc(8 * var(--w));
  padding: 0 calc(24 * var(--w));
}
.search-icon {
  width: calc(36 * var(--w));
  height: calc(36 * var(--w));
  flex-shrink: 0;
}
.placeholder {
  font-size: calc(28 * var(--w));
  color: #c8c9cc;
}
.my-apps-section {
  background: #fff;
  padding-bottom: calc(24 * var(--w));
}
.section-label {
  padding: calc(20 * var(--w)) calc(24 * var(--w)) calc(20 * var(--w)) calc(19 * var(--w));
  font-size: calc(50 * var(--w));
  color: #ff976a;
  border-left: calc(5 * var(--w)) solid #ff976a;
  margin-top: calc(16 * var(--w));
  background: #fff;
  line-height: 1.2;
}
.empty-tip {
  padding: calc(20 * var(--w)) calc(24 * var(--w));
  font-size: calc(30 * var(--w));
  color: #999;
}
.my-apps-grid {
  display: flex;
  flex-wrap: wrap;
  padding: 0 calc(24 * var(--w));
  gap: calc(32 * var(--w));
}
.my-app-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: calc(180 * var(--w));
}
.remove-btn {
  position: absolute;
  top: calc(-8 * var(--w));
  right: calc(8 * var(--w));
  width: calc(36 * var(--w));
  height: calc(36 * var(--w));
  cursor: pointer;
  z-index: 2;
}
.remove-icon {
  width: calc(36 * var(--w));
  height: calc(36 * var(--w));
}
.app-icon {
  width: calc(96 * var(--w));
  height: calc(96 * var(--w));
  object-fit: contain;
}
.app-name {
  font-size: calc(28 * var(--w));
  color: #323233;
  margin-top: calc(8 * var(--w));
  text-align: center;
  width: calc(160 * var(--w));
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.3;
}
/* 分类标签 */
.tabs {
  display: flex;
  background: #fff;
  overflow-x: auto;
  padding: 0 calc(24 * var(--w));
  gap: calc(32 * var(--w));
  height: calc(96 * var(--w));
  align-items: center;
  -webkit-overflow-scrolling: touch;
}
.tab {
  font-size: calc(50 * var(--w));
  color: #646566;
  white-space: nowrap;
  padding-bottom: calc(8 * var(--w));
  border-bottom: calc(3 * var(--w)) solid transparent;
  flex-shrink: 0;
}
.tab.active {
  color: #ff976a;
  font-weight: bold;
  border-bottom-color: #ff976a;
}
/* 服务列表 */
.service-list {
  background: #f5f5f5;
}
.service-group {
  margin-bottom: calc(16 * var(--w));
}
.group-title {
  padding: calc(20 * var(--w)) calc(24 * var(--w));
  font-size: calc(38 * var(--w));
  font-weight: bold;
  color: #323233;
  background: #fff;
  border-bottom: 1px solid #f5f5f5;
}
.service-item {
  display: flex;
  align-items: center;
  padding: calc(44 * var(--w)) calc(24 * var(--w));
  background: #fff;
  border-bottom: 1px solid #f5f5f5;
  gap: calc(20 * var(--w));
}
.item-icon {
  width: calc(64 * var(--w));
  height: calc(64 * var(--w));
  object-fit: contain;
  flex-shrink: 0;
}
.item-title {
  flex: 1;
  font-size: calc(46 * var(--w));
  color: #323233;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.item-expand {
  width: calc(40 * var(--w));
  height: calc(40 * var(--w));
  flex-shrink: 0;
  transition: transform 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.item-expand svg {
  width: calc(40 * var(--w));
  height: calc(40 * var(--w));
}
.item-expand.expanded {
  transform: rotate(180deg);
}
.action-btn {
  width: calc(40 * var(--w));
  height: calc(40 * var(--w));
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.check-icon {
  width: calc(40 * var(--w));
  height: calc(40 * var(--w));
}
.plus-icon {
  width: calc(40 * var(--w));
  height: calc(40 * var(--w));
}
.child-item {
  padding-left: calc(24 * var(--w));
  background: #fafafa;
}
.child-dot {
  width: calc(12 * var(--w));
  height: calc(12 * var(--w));
  border-radius: 50%;
  background: #07c160;
  flex-shrink: 0;
  margin-left: calc(20 * var(--w));
}
.child-item .item-title {
  font-size: calc(42 * var(--w));
  color: #646566;
}
</style>



// WEBPACK FOOTER //
// src/pages/ServiceCustomize.vue